import { useState, useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import exportFileType from "shared/lib/fileTypeExtractor"

// origin: string ( 초기 값 )
const usePostImgUpload = (origin) => {
    const [imgState, setImgState] = useState(null)
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        origin && setImgState(origin)
    }, [origin])

    const setImg = (e) => {
        const file = e.target.files[0]

        if (!file) setAlert("이미지가 선택되지 않았습니다.")
        else if (!["jpg", "jpeg", "png"].includes(exportFileType(file.name).toLowerCase())) setAlert("jpg, jpeg, png 이미지만 업로드 가능합니다.")
        else if (Math.round(file.size) > 20 * 1024 * 1024) setAlert("20mb 이하 이미지만 업로드 가능합니다.")
        else {
            const formdata = new FormData()
            formdata.append("src", file)
            fetchRequest("POST", "/admin/util/upload", null, formdata)
        }
    }

    const deleteImg = () => {
        setImgState(null)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setImgState(fetchResult?.data?.path)
                break
            case 400:
                if (fetchResult?.data?.error_code === "src") setAlert("이미지의 확장자와 용량을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [imgState, setImg, deleteImg]
}

export default usePostImgUpload